<template>
  <CRow class="main py-5">
    <CCol class="py-2">
      <transition name="fade">
        <MenssageAlert :messages="messages" />
      </transition>
      <CRow class="">
        <CCol class="">
          <div class="pb-2 h6">
            <h4 class="mt-4 font-weight-normal">
              {{ $route.name !== 'createSubOrganization' ? $t('settings.menu.option.organization') : $t('settings.menu.option.subOrganization') }}
            </h4>
          </div>
        </CCol>
        <CCol v-if="isEdit" class="d-flex justify-content-end">
          <!-- <router-link
            class="btn btn-primary px-4 font-weight-bold"
            tag="button"
            :to="{ name: 'createOrganization' }"
            >Create Organization</router-link> -->

          <CButton
            v-if="canUserCreateOrganization"
            type="submit"
            style="min-width: 150px"
            class="btn-primary px-4 mt-sm-2 mt-md-4 mr-3"
            color="primary"
            :to="{ name: 'createOrganization' }"
            >{{ $t('settings.organization.button.createOrganization') }}
          </CButton>
          <CButton
            v-if="canUserEditOrganization"
            type="submit"
            style="min-width: 150px"
            class="px-4 py-1 mt-sm-2 mt-md-4 btn-primary"
            color="primary"
            @click="() => (edit = !edit)"
          >
            {{ !edit ? $t('settings.menu.option.edit') : $t('settings.menu.option.cancel') }}
          </CButton>
        </CCol>
      </CRow>

      <Form :isEdit="isEdit" :isOrgRoot="isRootClientOrg" :edit="edit" @organizationChanged="organizationChanged" />
    </CCol>
  </CRow>
</template>

<script>
import Form from './Form'
import MenssageAlert from '@/components/MenssageAlert'
import organizationService from '../organization-services.js'
import { mapGetters } from 'vuex'

export default {
  name: 'MainOrganization',
  components: { Form, MenssageAlert },
  data() {
    return {
      edit: false,
      isEdit: true,
      isRootClientOrg: false,
      messages: [],
      canUserCreateOrganization: null,
      featuresIds: ['SUB_ORGANIZATIONS'],
    }
  },
  methods: {
    organizationChanged(messages) {
      this.messages = []
      this.messages.push(messages)
      this.scrollTop()
      if (messages.status === 'danger') {
        return
      }
      this.edit = false
    },

    canCreateOrganization() {
      let userId = this.$store.state.auth.user.id
      organizationService.canCreateOrganization(userId).then((res) => {
        this.canUserCreateOrganization = res.data.data
      })
    },

    organizationIsRoot() {
      organizationService
        .organizationRoot(this.$route.params.organizationId)
        .then((res) => {
          this.isRootClientOrg = res.data.data.organizationId == this.$route.params.organizationId && res.data.data.organizationType == 2
        })
        .catch((err) => {
          throw err
        })
    },

    scrollTop: function () {
      this.intervalId = setInterval(() => {
        if (window.pageYOffset === 0) {
          clearInterval(this.intervalId)
        }
        window.scroll(0, window.pageYOffset - 50)
      }, 20)
    },
  },
  computed: {
    ...mapGetters({
      hasSessionPermission: 'auth/hasSessionPermission',
    }),

    canUserEditOrganization() {
      return this.hasSessionPermission('Organization_Edit')
    },
  },
  mounted() {
    this.canCreateOrganization()
    if (this.$route.params.organizationId) {
      this.organizationIsRoot()
    }
    this.isEdit =
      this.$route.name !== 'createOrganization' && this.$route.name !== 'createOrganization-default' && this.$route.name !== 'createSubOrganization'
    this.edit = !this.isEdit
  },
}
</script>

<style scoped>
.border-line {
  border-bottom: 2px solid #d1d4da;
}
</style>
